export const breakpoints = {
    base: 0,
    xxs: 480,
    xs: 575,
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    '2xl': 1440,
    '3xl': 1536,
    '4xl': 1920,
};
export const imgBreakpoints = {
    0: { breakpoint: 'base', desiredWidth: 320 },
    320: { breakpoint: 'xxs', desiredWidth: 412 },
    412: { breakpoint: 'xxs', desiredWidth: 480 },
    480: { breakpoint: 'xxs', desiredWidth: 560 },
    560: { breakpoint: 'xs', desiredWidth: 575 },
    575: { breakpoint: 'xs', desiredWidth: 640 },
    640: { breakpoint: 'sm', desiredWidth: 720 },
    720: { breakpoint: 'sm', desiredWidth: 768 },
    768: { breakpoint: 'md', desiredWidth: 800 },
    800: { breakpoint: 'md', desiredWidth: 880 },
    880: { breakpoint: 'md', desiredWidth: 960 },
    960: { breakpoint: 'md', desiredWidth: 1024 },
    1024: { breakpoint: 'lg', desiredWidth: 1040 },
    1040: { breakpoint: 'lg', desiredWidth: 1120 },
    1120: { breakpoint: 'lg', desiredWidth: 1200 },
    1200: { breakpoint: 'lg', desiredWidth: 1280 },
    1280: { breakpoint: 'xl', desiredWidth: 1360 },
    1360: { breakpoint: 'xl', desiredWidth: 1440 },
    1440: { breakpoint: '2xl', desiredWidth: 1520 },
    1520: { breakpoint: '3xl', desiredWidth: 1600 },
    1600: { breakpoint: '3xl', desiredWidth: 1680 },
    1680: { breakpoint: '3xl', desiredWidth: 1760 },
    1760: { breakpoint: '3xl', desiredWidth: 1840 },
    1840: { breakpoint: '3xl', desiredWidth: 1920 },
    1920: { breakpoint: '4xl', desiredWidth: 2160 },
    2160: { breakpoint: '4xl', desiredWidth: 2320 },
    2320: { breakpoint: '4xl', desiredWidth: 2320 },
};
export function breakpoint(breakpoint) {
    return `${breakpoints[breakpoint]}px`;
}
export function isAtLeastBreakpoint(breakpoint) {
    return window.matchMedia(`(min-width: ${breakpoints[breakpoint]}px)`).matches;
}
